import React from "react";
import * as Styled from "./styled";

interface IProps {
  onClose(): void;
}

const DialogComponent = ({
  children,
  onClose,
}: React.PropsWithChildren<IProps>) => {
  const handleClose = React.useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Styled.Root>
      <Styled.Dim onClick={handleClose} />
      <Styled.Container>{children}</Styled.Container>
    </Styled.Root>
  );
};

export default DialogComponent;
